import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('guaranteedDeliveryFields',  {
    bindings: {
      formName: '@',
      formId: '@',
      guaranteedDelivery: '<',
      guaranteedTier: '@',
      guaranteedTierMappings: '<',
      guaranteedTierDefault: '@',
    },
    template: require("../templates/guaranteedDeliveryFields.html"),
    controllerAs: '$guaranteedDeliveryFieldsCtrl',
    controller: ['$rootScope', function($rootScope) {
      const self = this;

      this.attributeEnabledMappings = componentHelper.attributeEnabledMappings();

      this.setGuaranteedDelivery = (value) => {
        this.guaranteedDelivery = value;
        this.guaranteedTier = value ? this.guaranteedTierDefault : null;
      };

      this.guaranteedDeliveryTooltip = function (guaranteedDeliveryValue) {
        if (self.formName !== "campaign") {
          return "";
        }

        switch (guaranteedDeliveryValue) {
          case true:
            return "Add demand tag(s) with valid budgets before enabling Guaranteed Delivery";
          default:
            return "";
        }
      };
  
    }]
});
